import EcommerceProductModel from "@/Interfaces/Product/EcommerceProductModel";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useShoppingCartStore = defineStore('shopping-cart', () => {
    const wishListItems = ref<EcommerceProductModel[]>([]);
    const cartItems = ref<EcommerceProductModel[]>([]);
    const localStorageCartItems = ref<EcommerceProductModel[]|null>(null);
    const localStorageWishListItems = ref<EcommerceProductModel[]|null>(null);
    const visibleRight = ref(false);

    return {
        cartItems,
        localStorageCartItems,
        wishListItems,
        localStorageWishListItems,
        visibleRight
    }
});